import type { ConnectedProps } from 'react-redux'
import { connect } from 'react-redux'

import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import { LabRemoteConfigKeys } from 'constants/lab'
import { getLanguageOptions } from 'i18n/util/locale'
import { isLEStaff } from 'selectors/accountSelectors'
import { buildUrl } from 'lib/url/searchUrlUtils'

interface Props {
  to: string
}

function Redirect(props: Props & ConnectedProps<typeof connector>) {
  return (
    <RedirectWithStatus
      code={302}
      to={buildUrl(props.to, props.regionCode, undefined, undefined, { locale: props.locale, languageOptions: props.languageOptions })}
    />
  )
}

function mapStateToProps(state: App.State) {
  return {
    regionCode: state.geo.currentRegionCode,
    locale: state.geo.locale,
    languageOptions: getLanguageOptions(
      state.system.features.remoteConfigFlags?.[LabRemoteConfigKeys.languages],
      isLEStaff(state),
    ).languageOptions,
  }
}

const connector = connect(mapStateToProps)

export default connector(Redirect)
